import React, { useEffect, useState } from "react";
import "./employee_concern.css";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import {
  HR_CONNECT_EMPLOYEE_CONCERN_LIST,
} from "../../../routes";
import { Loader } from "@progress/kendo-react-indicators";
import moment from "moment";
import { Stepper } from "@progress/kendo-react-layout";
import { CustomStep } from "../../../components/common/custom_steps";
import { ShowDialog } from "../../../components/reusableItems/dialog";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { fetchEmployeeConcernAudit, fetchEmployeeConcernDetail, updateEmployeeConcernStatus } from "../../../store/employee_concern";
import { statusConfig } from "./configData";

export const EmployeeConcernDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const id = query.get("id");
  const [detailLoading, setDetailLoading] = useState(false);
  const [auditLoading, setAuditLoading] = useState(false);
  const [detailData, setDetailData] = useState({});
  const [auditData, setAuditData] = useState([]);
  const [tempStatus, setTempStatus] = useState("");
  const [showStatus, setShowStatus] = useState(false);
  const userPermissions = getUserPermission();
  const viewPermssion = checkPermission(
    userPermissions,
    "hr_connect.access_employee_concern"
  );
  const EditPermssion = checkPermission(
    userPermissions,
    "hr_connect.update_status_employee_concern"
  );
  const getData = () => {
    setDetailLoading(true);
    setAuditLoading(true);
    dispatch(fetchEmployeeConcernAudit(id)).then((res) => {
      console.log(res.payload);

      if (res.payload.status_code === 200) {
        setAuditData(res.payload.data);
        setAuditLoading(false);
      } else {
        setAuditLoading(false);
        alert(res.payload.message);
      }
    });
    dispatch(fetchEmployeeConcernDetail(id)).then((res) => {
      console.log(res.payload);

      if (res.payload.status_code === 200) {
        // dispatch(fetAud)
        setTempStatus(res.payload.data.status);
        setDetailData(res.payload.data);
        setDetailLoading(false);
      } else {
        setDetailLoading(false);
        alert(res.payload.message);
      }
    });
  };
  useEffect(() => {
    getData();
  }, [id]);

  const updateStatus = () => {
    setShowStatus(false);
    setDetailLoading(true);
    let params = {
      id: id,
      status: tempStatus,
    };
    dispatch(
      updateEmployeeConcernStatus({ data: params, id: id })
    ).then((res) => {
      if (res.payload.status_code === 200) {
        setTempStatus("");
        getData();
      } else {
        setDetailLoading(false);
        alert(res.payload.message);
      }
    });
  };


  const RenderRow = ({ title, value }) => {
    return (
      <>
        {value ? (
          <>
            <div className="employee_concern_detail_child_box_main_detail_items">
              <div className="employee_concern_detail_child_box_main_detail_items_title employee_concern_detail_center_item employee_concern_detail_padding_bottom">
                {title}
              </div>
              <div className="employee_concern_detail_child_box_main_detail_items_splitter" />
              <div className="employee_concern_detail_center_item employee_concern_detail_child_box_main_detail_items_subdetail employee_concern_detail_padding_bottom">
                <>
                  <div dangerouslySetInnerHTML={{ __html: value }} />
                </>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };


  function getFilteredStatus(tempStatus) {
    if (tempStatus === "Closed") {
      return [];
    }

    if (tempStatus === "Investigating") {
      return ["Closed"];
    }

    if (tempStatus === "Submitted") {
      return ["Investigating"];
    }
    return [];
  }

  return (
    <>
      {viewPermssion ? (
        <>

          {showStatus && (
            <ShowDialog
              cancelbtn={() => setShowStatus(false)}
              title={"Update Status"}
              dropdown={true}
              cancelContent={"Cancel"}
              confrimContent={"Update"}
              confrinbtn={updateStatus}
              dropdownData={getFilteredStatus(tempStatus)}
              dropdownOnChange={(e) => setTempStatus(e)}
              dropdownValue={tempStatus}
            />
          )}

          {detailLoading ? (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          ) : (
            <div className="employee_concern_detail_main_box">
              <div className="employee_concern_detail_child_box">
                <div className="employee_concern_detail_left_box">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      className="employee_concern_detail_back"
                      onClick={() => navigate(HR_CONNECT_EMPLOYEE_CONCERN_LIST)}
                    >
                      <span class="k-icon k-font-icon k-i-arrow-chevron-left" />
                      Back
                    </div>

                  </div>
                  <div className="employee_concern_detail_child_box_main_detail_box">

                    <RenderRow
                      title={"Submission No."}
                      value={detailData && detailData.submission_no
                        ? detailData.submission_no
                        : "-"}
                    />
                    <RenderRow
                      title={"What is Your Concern Related To"}
                      value={detailData && detailData.related_to
                        ? detailData.related_to
                        : "-"}
                    />
                    <RenderRow
                      title={"Concern Details"}
                      value={detailData && detailData.details
                        ? detailData.details
                        : "-"}
                    />
                    <RenderRow
                      title={"Submitted On"}
                      value={detailData && detailData.created_on
                        ? moment(new Date(detailData.created_on)).format(
                          "DD MMM YYYY, hh:mm a"
                        )
                        : "-"}
                    />
                    <RenderRow
                      title={"Submitted By"}
                      value={detailData && detailData.created_by?.name
                        ? detailData.created_by.name
                        : "-"}
                    />


                    <div className="employee_concern_detail_child_box_main_detail_items">
                      <div className="employee_concern_detail_child_box_main_detail_items_title employee_concern_detail_center_item">
                        Image Upload
                      </div>
                      <div className="employee_concern_detail_child_box_main_detail_items_splitter" />
                      <div className="employee_concern_detail_center_item employee_concern_detail_child_box_main_detail_items_subdetail">

                        <div className="employee_concern_photos_grid">
                          {detailData.photos?.map((photo, index) => (
                            <div key={index} className="employee_concern_doc_viewer_item">
                              <img
                                src={photo}
                                alt={`photo-${index}`}
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  borderRadius: "8px",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div className="employee_concern_detail_right_box">
                  <div className="employee_concern_detail_right_status_box">
                    <div className="employee_concern_detail_right_box_status_title">
                      Status
                    </div>
                    <div className="employee_concern_detail_right_box_status_subdetail">
                      {detailData && detailData.status
                        ? detailData.status
                        : "-"}
                    </div>
                  </div>
                  {detailData.status !== "Closed" &&
                    <div className="employee_concern_detail_right_box_action_main_box">
                      <div className="employee_concern_detail_right_box_action_title">
                        Actions
                      </div>

                      {EditPermssion ? (
                        <div
                          className="employee_concern_detail_right_box_action_edit"
                          onClick={() => setShowStatus(true)}
                        >
                          Update Status &#x2192;
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  }


                  <div className="employee_concern_detail_right_box_action_main_box">
                    <div className="employee_concern_detail_right_box_action_title">
                      Activity Trail
                    </div>
                    <div className={auditData.length <= 1 && "audit_bar_hide"}>
                      {auditLoading ? (
                        <Loader
                          type="converging-spinner"
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#ffffff4d",
                          }}
                        />
                      ) : (
                        <Stepper
                          orientation={"vertical"}
                          items={auditData}
                          item={CustomStep}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
